import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['brandIdField']

  onStoreIdChange(event) {
    // 店舗を選択した場合はブランドIDを無効にする
    this.brandIdFieldTarget.disabled = !!event.currentTarget.value
  }
}
